import { motion } from 'framer-motion'
import { LINKS } from './NewSidebar'
import { Fragment, useEffect, useRef, useState } from 'react'
import { HorizontalLine, ItemData, LinkItemRow } from '../../styles/newStyles/MobileModal.styled'
import Text from '../../core/utils/Text'
import { FaChevronLeft, FaPallet } from 'react-icons/fa6'
import { useLocation } from 'react-router-dom'
import useClickOutside from '../../core/hooks/useClickOutside'
import ThemeToggler from '../common/Toggler'
import { IoColorPaletteOutline, IoLogOutOutline } from 'react-icons/io5'
import { useAuthContext } from '../../core/contexts/auth'

const RespNavigationModal = ({ onClose }) => {
	const ref = useRef()
	useClickOutside(ref, onClose)
	const { logout } = useAuthContext()
	const [activeLinkIndex, setActiveLinkIndex] = useState(-1)
	const { pathname } = useLocation()

	useEffect(() => {
		if (pathname.includes('/authentication')) setActiveLinkIndex(2)
		else if (pathname === '/trade') setActiveLinkIndex(5)
		else if (pathname === '/notifications') setActiveLinkIndex(8)
		else if (pathname === '/profile') setActiveLinkIndex(9)
		else if (pathname === '/profile/cards&accounts') setActiveLinkIndex(10)
		else if (pathname === '/profile/security') setActiveLinkIndex(11)
		else if (pathname === '/profile/invite-friends') setActiveLinkIndex(12)
	}, [pathname])

	const renderedItems = LINKS.map((item, index, array) => {
		const { Icon } = item
		return item.inResp ? (
			<Fragment key={item.text}>
				<LinkItemRow to={item.href} className={`${item.inResp ? '' : 'hidden'}`}>
					<ItemData>
						<Icon color={activeLinkIndex === index ? '#804BEB' : '#A6A9B9'} />
						<Text tid={item.text} className={'text-sm'} />
					</ItemData>
					<FaChevronLeft />
				</LinkItemRow>
				{index !== array.length - 1 && <HorizontalLine />}
			</Fragment>
		) : null
	})

	return (
		<motion.div
			animate={{ y: 0, transition: { type: 'ease' } }}
			exit={{ y: -600, transition: { type: 'ease' } }}
			initial={{ y: -600 }}
			className={
				'fixed top-0 z-[1000] left-0 w-screen max-h-[700px] overflow-y-auto dark:bg-dark bg-white p-5'
			}
			ref={ref}
		>
			<ul className='flex flex-col gap-y-2'>
				{renderedItems}
				<HorizontalLine />
				<ItemData className=''>
					<IoColorPaletteOutline size={22} color='#A6A9B9' />
					<Text tid={'theme'} />
					<div className='mr-auto' />
					<ThemeToggler />
				</ItemData>
				<ItemData onClick={logout} className='!justify-center bg-red-200 py-3 rounded-lg'>
					<IoLogOutOutline size={22} color='#C33' />
					<Text tid={'logout'} className='text-[#C33]' />
				</ItemData>
			</ul>
		</motion.div>
	)
}

export default RespNavigationModal
